import { PatientDataProtectionPolicy } from "@/components";
import useBackward from "@/hooks/useBackward";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import AppBar from "@mui/material/AppBar";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/patient-policy")({
	component: RouteComponent,
});

function RouteComponent() {
	const handleOnBack = useBackward();
	return (
		<div className="h-full container relative flex flex-col">
			<AppBar position="fixed" className="!bg-white !shadow-none">
				<Toolbar variant="dense" className="wrapper w-full h-14">
					<IconButton
						edge="start"
						color="inherit"
						aria-label="backspace"
						className="mr-2"
						onClick={() => handleOnBack()}
					>
						<KeyboardBackspaceIcon className="text-dark text-2xl" />
					</IconButton>
					<p className="text-sm text-dark font-semibold">
						Patient Data Protection Policy
					</p>
				</Toolbar>
			</AppBar>
			<div className="flex-1 mt-12 py-4">
				<PatientDataProtectionPolicy />
			</div>
		</div>
	);
}
